// extracted by mini-css-extract-plugin
export default {"bottom-sheet":"ur8gk5","bottom-sheet__overlay":"wdKJnO","bottom-sheet__container":"Cdl9o5","bottom-sheet__sticky-wrapper":"S02tS0","bottom-sheet__close":"WjwMKO"};